import React, { useContext, useState } from 'react';
import { MenuProps } from './interfaces';
import './styles.scss';
import SspProviderContext from '../../utils/SspProvider/context';
import A from '../AutostadtA';
import { setASSubpage } from '../../utils/SspProvider/dispatchFunctions';
import { ASSubpageEnum, PageChildrenEnum } from '../../enums';
import Submenu from './Submenu';
import i18next from 'i18next';

export default function Menu(props: MenuProps) {
    const store = useContext(SspProviderContext);

    const [subList, setSubList] = useState<number>(0);
    const [isVisble, setIsVisible] = useState<boolean>(false);

    return (
        <div className='menu'>
            <A name='autostadt' fill='url(#linear-gradient-A)' firstColor='#00ABE9' secondColor='#21307D' />

            <div className='text-area'>
                <ul className='main-list'>
                    <li
                        onClick={() => {
                            setSubList(1);
                            setIsVisible(true);
                        }}
                    >
                        <div
                            className={`main-link ${
                                props.activePage === PageChildrenEnum.Expose ? ' active-item' : ''
                            }`}
                        >
                            <svg className='menu-icon icon-24'>
                                <use xlinkHref='#car' />
                            </svg>

                            <div className='menu-item-wrapper'>
                                <span className={subList === 1 ? 'main-link-active bold' : 'bold'}>MEIN FAHRZEUG</span>
                                <p className='description large'>{i18next.t('ExposeMenuSubline')}</p>
                            </div>

                            <svg className='chevron-icon icon-24'>
                                <use xlinkHref='#as-chevron' />
                            </svg>
                        </div>
                    </li>

                    <li
                        onClick={() => {
                            setSubList(3);
                            setIsVisible(true);
                        }}
                    >
                        <div
                            className={`main-link ${
                                props.activePage === PageChildrenEnum.PickUp ? ' active-item' : ''
                            }`}
                        >
                            <svg className='menu-icon icon-24'>
                                <use xlinkHref='#story' />
                            </svg>

                            <div className='menu-item-wrapper'>
                                <span className={subList === 3 ? 'main-link-active bold' : 'bold'}>
                                    MEINE ERLEBNISABHOLUNG
                                </span>
                                <p className='description large'>{i18next.t('PickUpMenuSubline')}</p>
                            </div>

                            <svg className='chevron-icon icon-24'>
                                <use xlinkHref='#as-chevron' />
                            </svg>
                        </div>
                    </li>

                    <li
                        onClick={() => {
                            setSubList(2);
                            setIsVisible(true);
                        }}
                    >
                        <div
                            className={`main-link ${props.activePage === PageChildrenEnum.Story ? ' active-item' : ''}`}
                        >
                            <svg className='menu-icon icon-24'>
                                <use xlinkHref='#home' />
                            </svg>
                            <div className='menu-item-wrapper'>
                                <span className={subList === 2 ? 'main-link-active bold' : 'bold'}>VOLKSWAGEN</span>

                                <p className='description large'>{i18next.t('StoryMenuSubline')}</p>
                            </div>

                            <svg className='chevron-icon icon-24'>
                                <use xlinkHref='#as-chevron' />
                            </svg>
                        </div>
                    </li>
                </ul>

                <div className='further'>
                    <ul className='further-links'>
                        <li
                            onClick={() => {
                                props.setMenuOpen(false);
                                setASSubpage(store, {
                                    asEnum: ASSubpageEnum.Contact,
                                });
                            }}
                        >
                            <svg className='icon-24'>
                                <use xlinkHref='#as-arrow-right'></use>
                            </svg>
                            <span>Kontakt</span>
                        </li>

                        <li
                            onClick={() => {
                                props.setMenuOpen(false);
                                setASSubpage(store, {
                                    asEnum: ASSubpageEnum.OpeningHours,
                                });
                            }}
                        >
                            <svg className='icon-24'>
                                <use xlinkHref='#as-arrow-right'></use>
                            </svg>
                            <span>Öffnungszeiten</span>
                        </li>

                        <li>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-link-external'></use>
                            </svg>
                            <span>
                                <a rel='noreferrer' target='_blank' href='https://www.autostadt.de'>
                                    Autostadt
                                </a>
                            </span>
                        </li>
                        <li>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-link-external'></use>
                            </svg>
                            <span>
                                <a rel='noreferrer' target='_blank' href='https://www.autostadt.de/service-kontakt/faq'>
                                    FAQ
                                </a>
                            </span>
                        </li>
                        <li>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-link-external'></use>
                            </svg>
                            <span>
                                <a
                                    rel='noreferrer'
                                    target='_blank'
                                    href='https://www.autostadt.de/service-kontakt/newsletter'
                                >
                                    Newsletter
                                </a>
                            </span>
                        </li>
                        <li>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-link-external'></use>
                            </svg>
                            <span>
                                <a
                                    rel='noreferrer'
                                    target='_blank'
                                    href='https://autostadt.survalyzer.eu/nrrgodwpvh?l=de'
                                >
                                    Feedback
                                </a>
                            </span>
                        </li>
                        <li>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-link-external'></use>
                            </svg>
                            <span>
                                <a
                                    rel='noreferrer'
                                    target='_blank'
                                    href='https://www.autostadt.de/rechtliches/datenschutzerklaerung-abholer-webapp'
                                >
                                    Datenschutzerklärung
                                </a>
                            </span>
                        </li>
                        <li>
                            <svg className='icon-24'>
                                <use xlinkHref='#as-link-external'></use>
                            </svg>
                            <span>
                                <a rel='noreferrer' target='_blank' href='https://www.autostadt.de/footer/impressum'>
                                    Impressum
                                </a>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <Submenu
                isVisible={isVisble}
                activeSublist={subList}
                setIsVisible={() => setIsVisible(false)}
                setMenuOpen={props.setMenuOpen}
                editorialContent={props.editorialContent}
                activePage={props.activePage}
            />

            <div className='menu-close-container'>
                <button
                    className={`icon-24 close-button-menu ${subList !== 0 ? ' close-sub-list' : ''}`}
                    aria-label='Schließen'
                    onClick={() => {
                        props.setMenuOpen(false);
                    }}
                >
                    <svg>
                        <use xlinkHref='#as-close' />
                    </svg>
                </button>
            </div>
            <div className={`blue-stripe ${isVisble ? 'visible' : 'hidden'}`} />
        </div>
    );
}
